/**
 * Owner: Masa Bayu
 * File: advanced-media.ts
 * Date:Time: 2026-09-16 18:50
 * Description: T8-E4 Media chrome intent — QXRead packages; QXReader executes.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { assertT8E4SecurityIntact } from './advanced-security';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
export const QXREAD_MEDIA_INTENT_KINDS = ['play', 'pause', 'caption', 'transcript'];
function assertKind(value, label) {
    if (typeof value !== 'string' ||
        !QXREAD_MEDIA_INTENT_KINDS.includes(value)) {
        throw new Error(`${label} must be one of: ${QXREAD_MEDIA_INTENT_KINDS.join(', ')}`);
    }
    return value;
}
export function createMediaChromeIntent(input) {
    assertNoForbiddenFoundationKey(input, 'QXRead Media intent');
    assertT8E4SecurityIntact();
    assertValidId(input.publicationId, 'QXRead media publicationId');
    const createdAt = input.createdAt ?? new Date().toISOString();
    assertTimestamp(createdAt, 'QXRead media createdAt');
    const mediaIntentId = input.mediaIntentId !== undefined ? input.mediaIntentId : createQxreadId('qxrdmed');
    assertValidId(mediaIntentId, 'QXRead mediaIntentId');
    return Object.freeze({
        mediaIntentId,
        publicationId: input.publicationId,
        kind: assertKind(input.kind, 'QXRead media kind'),
        createdAt,
        executesInQxread: false,
        executesInQxReader: true,
        inventsEntitlement: false,
        mutatesQxp: false,
    });
}
//# sourceMappingURL=advanced-media.js.map